module.exports = __webpack_public_path__ + "img/c72f6f2.png";